import React from "react";
import useQuery from "../hooks/useQuery";
import ApplyEmail from "../components/Apply/ApplyEmail";
import ApplyError from "../components/Apply/ApplyError";

const ApplyResult = () => {
  const queryResult = useQuery();

  const applyResult = () => {
    const operation = queryResult.get("operation");
    const paymentProviderOperation = queryResult.get("collection_status");

    if (operation === "success" && paymentProviderOperation === "approved") {
      return <ApplyEmail />;
    } else {
      return <ApplyError />;
    }
  };
  return <>{applyResult()}</>;
};

export default ApplyResult;
